// extracted by mini-css-extract-plugin
module.exports = {"tags__inner":"bt_jk","tags":"bt_jl","tags__label":"bt_jm","tags_negative":"bt_jn"};